import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "../components/flexproducts";
import Header from "../headers_footer/header";

const O3plus = () => {

return (

<div>

<Navbar />
<Flexproducts type="o3plus" />
<Header></Header>

</div>

);
};

export default O3plus;